import type { Dispatch } from '@reduxjs/toolkit';
import { handleError } from 'services/ErrorHandle';
import type { IExportPcsRequest, IExportProcosRequest } from '../../types';
import { EApiType } from '../data/Constants';
import ApiUrl from '../services/APIUrl';
import AxiosClient from './AxiosClient';
import { handleSuccess } from './HttpUtil';

export const ExportApi = {
  /**
   * Exports Procos data by calling the API endpoint /report/v1/product/procos/excel.
   * Downloads the procos data as a blob response.
   *
   * @param {IExportProcosRequest} action - The export configuration object containing the procos data parameters.
   * @param {Dispatch} [dispatch] - Optional Redux dispatch function for handling success or error actions.
   * @returns {Promise} A promise that resolves with the download response or handles errors.
   */
  exportProcos: (action: IExportProcosRequest, dispatch?: Dispatch) => {
    return AxiosClient.post(ApiUrl.ProcosExport, action, { responseType: 'blob' })
      .then((response) => {
        return handleSuccess(response, EApiType.Download, dispatch);
      })
      .catch(async (err) => {
        const text = await err?.response?.data?.text?.();
        const errorData = text ? JSON.parse(text) : err;
        return handleError(errorData, EApiType.Download, dispatch);
      });
  },

  /**
   * Exports PCS data by calling the API endpoint /report/v1/product/pcs/excel.
   * Downloads the PCS data as a blob response.
   *
   * @param {IExportPcsRequest} action - The export configuration object containing the PCS data parameters.
   * @param {Dispatch} [dispatch] - Optional Redux dispatch function for handling success or error actions.
   * @returns {Promise} A promise that resolves with the download response or handles errors.
   */
  exportPcs: (action: IExportPcsRequest, dispatch?: Dispatch) => {
    return AxiosClient.post(ApiUrl.PcsExport, action, { responseType: 'blob' })
      .then((response) => {
        return handleSuccess(response, EApiType.Download, dispatch);
      })
      .catch(async (err) => {
        const text = await err?.response?.data?.text?.();
        const errorData = text ? JSON.parse(text) : err;
        return handleError(errorData, EApiType.Download, dispatch);
      });
  },
};
